import state from './config';
import mutations from './mutations';
export default {
  state,
  mutations,
  getters: {
    /*getUserInfo(state) {
      return state.userInfo;
    }*/
  },
  actions: {
    /*setUserInfo({commit}, user) {
      commit('setUserInfo', user);
    }*/
  }
};



// WEBPACK FOOTER //
// ./src/vuex/index.js